export enum CandidateStatusColor {
  White = "White",
  Green = "Green",
  Blue = "Blue",
  Purple = "Purple",
  Yellow = "Yellow",
  Red = "Red",
}
